import {Header, Tabs} from '@/components';
import type {TabItem} from '@/types';

import {EventTierListTab} from './EventTierListTab';
import {MerchantTierListTab} from './MerchantTierListTab';
import {ReferralTierListTab} from './ReferralTierListTab';
import {SignupBonusListTab} from './SignupBonusListTab';
import useEventTierList from './useEventTierList';
import useSignupBonusList from './useSignupBonusList';
import useTierList from './useTierList';

const Tierlist = () => {
  const {total: tierListTotal} = useTierList('referral');
  const {total: signupCodeTotal} = useSignupBonusList();
  const {total: eventTierTotal} = useEventTierList();
  const {total: merchantTierListTotal} = useTierList('merchant-aggregator');

  const tierFigure = tierListTotal
    ? ` (${tierListTotal.toLocaleString()})`
    : '';
  const signupCodeFigure = signupCodeTotal
    ? ` (${signupCodeTotal.toLocaleString()})`
    : '';
  const eventTierFigure = eventTierTotal
    ? ` (${eventTierTotal.toLocaleString()})`
    : '';
  const merchantTierFigure = merchantTierListTotal
    ? ` (${merchantTierListTotal.toLocaleString()})`
    : '';

  const tabs: TabItem[] = [
    {
      id: 'tiers',
      title: 'Referral Tiers' + tierFigure,
      content: <ReferralTierListTab key="tiers" />,
    },
    {
      id: 'merchant',
      title: 'Merchant Tiers' + merchantTierFigure,
      content: <MerchantTierListTab key="merchant" />,
    },
    {
      id: 'signup',
      title: 'Signup Bonus Tiers' + signupCodeFigure,
      content: <SignupBonusListTab key="signup" />,
    },
    {
      id: 'event',
      title: 'Event Tiers' + eventTierFigure,
      content: <EventTierListTab key="event" />,
    },
  ];
  return (
    <div className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={'Referral Tiers List'} />
      <Tabs tabs={tabs} />
    </div>
  );
};

export default Tierlist;
